import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const HR: DeepPartial<Payments> = {
    shouldPrefillSenderNameFromAccount: false,
    shouldLoadBanks: true,
    useReceiverEndpoint: true,
    handleLocalErrors: {
        errorCode: 'HR-BE_LOCAL_ERROR',
        translationPath: 'parameters.HR-BE_ERR_TXT',
    },
    putCancelledByUserToDone: true,
    additionalCopyableAttributes: ['hr-paymentSpecifics', 'paymentPurpose'],
    localAccountId: 'hr-id',
    maxDaysInFuture: 365,
    trustedContactsAvailable: true,
};
